module.exports = __webpack_public_path__ + "img/ludi bruche 2024.3c9f8081.webp";